import http from "./httpService";
import getApiEndpoint from "./apiEndpoint";
import { LinkType } from "../types/appTypes";

const apiEndpoint = `${getApiEndpoint()}/link`;

export function getLink(id: string) {
  return http.get<{ data: LinkType }>(`${apiEndpoint}/${id}`);
}
